export const escapeKey = (s) => {
    return s.replace(/[.$[\]#/]/g, "_");
};
const kProblemPathRegEx = /(.+)\/(\d)\/(\d)$/;
export const isProblemPath = (key) => {
    // if it looks like a section path, assume it is one
    return key ? kProblemPathRegEx.test(key) : false;
};
/*
 * parseProblemPath
 *
 * Parses strings of following form, returning a component array:
 *  "msa/1/2" => ["msa", "1, "2"]
 * In other words, on success the returned array contains:
 *  [unit, investigation, problem]
 */
export const parseProblemPath = (key) => {
    const result = kProblemPathRegEx.exec(key || "");
    return result ? result === null || result === void 0 ? void 0 : result.slice(1) : undefined;
};
/*
 * isSectionPath
 *
 * Matches strings of following form:
 *  "msa/1/2/introduction"
 *  "msa:guide/1/2/introduction"
 */
const kSectionPathRegEx = /([^:]+)(:(.+))?\/(\d)\/(\d)\/(.+)$/;
export const isSectionPath = (key) => {
    // if it looks like a section path, assume it is one
    return key ? kSectionPathRegEx.test(key) : false;
};
/*
 * parseSectionPath
 *
 * Parses strings of following form, returning a component array:
 *  "msa/1/2/introduction" => ["msa", undefined, "1, "2", "introduction"]
 *  "msa:guide/1/2/introduction" => ["msa", "guide", "1, "2", "introduction"]
 * In other words, on success the returned array contains:
 *  [unit, facet?, investigation, problem, section]
 */
export const parseSectionPath = (key) => {
    const result = kSectionPathRegEx.exec(key || "");
    return result ? [result[1], ...result.slice(3)] : undefined;
};
const facetMap = {
    "teacher-guide": "guide"
};
export const buildProblemPath = (unitCode, investigationOrdinal, problemOrdinal) => {
    return `${unitCode}/${investigationOrdinal}/${problemOrdinal}`;
};
export const buildSectionPath = (problemPath, section, facet) => {
    var _a;
    const [unit, investigation, problem] = parseProblemPath(problemPath) || [];
    if (!unit || !investigation || !problem)
        return;
    const facetCode = (_a = (facet && facetMap[facet])) !== null && _a !== void 0 ? _a : facet;
    const facetField = facetCode ? `:${facetCode}` : "";
    const sectionField = section ? `/${section}` : "";
    return `${unit}${facetField}/${investigation}/${problem}${sectionField}`;
};
export const getCurriculumMetadata = (sectionPath) => {
    const [unit, facet, investigation, problem, section] = parseSectionPath(sectionPath) || [];
    return sectionPath && unit && investigation && problem && section
        ? { unit, facet, problem: `${investigation}.${problem}`, section, path: sectionPath }
        : undefined;
};
export const kExemplarUserParams = {
    type: "student",
    id: "ivan_idea_1",
    firstName: "Ivan",
    lastName: "Idea",
    fullName: "Ivan Idea",
    initials: "II",
};
export const kAnalyzerUserParams = {
    type: "student",
    id: "ada_insight_1",
    firstName: "Ada",
    lastName: "Insight",
    fullName: "Ada Insight",
    initials: "AI",
};
/*
 * networkDocumentKey
 *
 * To accommodate the fact that the same document can be commented upon in multiple networks, the
 * id of a document in firestore is a mashup of the network/uid and the document key.
 */
export function networkDocumentKey(uid, documentKey, network) {
    const escapedKey = escapeKey(documentKey);
    const escapedNetwork = network && escapeKey(network);
    const prefix = escapedNetwork || `uid:${uid}`;
    return `${prefix}_${escapedKey}`;
}
export function getDocumentPath(userId, documentKey, network) {
    const networkDocKey = networkDocumentKey(userId, documentKey, network);
    const documentPath = `documents/${networkDocKey}`;
    return documentPath;
}
export function getSimpleDocumentPath(documentKey) {
    return isSectionPath(documentKey)
        ? `curriculum/${escapeKey(documentKey)}`
        : `documents/${escapeKey(documentKey)}`;
}
export function isDocumentMetadata(o) {
    return !!o.uid && !!o.type && !!o.key;
}
export function isCurriculumMetadata(o) {
    return !!(o === null || o === void 0 ? void 0 : o.unit) && !!o.problem && !!o.section && !!o.path;
}
export function isWarmUpParams(o) {
    return !!(o === null || o === void 0 ? void 0 : o.warmUp);
}
//# sourceMappingURL=data:application/json;base64,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